import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import type { LicensePickerConfig } from '../../../types/ticketTypeTemplate';
import { LICENSE_CATEGORY_OPTIONS } from '../../../data/licenseCategories';
import { FIELD_SX } from '../../../styles/designSystem';
import '../EditorCard.css';

interface LicensePickerConfigEditorProps {
  value: LicensePickerConfig | undefined;
  onChange: (next: LicensePickerConfig) => void;
}

export const LicensePickerConfigEditor: React.FC<LicensePickerConfigEditorProps> = ({
  value,
  onChange,
}) => {
  const catalogCategory = value?.catalogCategory ?? LICENSE_CATEGORY_OPTIONS[0].value;
  const mode = value?.mode ?? 'all';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <span className="editor-section-title">License Picker Config</span>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <FormControl size="small" sx={[{ minWidth: 200 }, FIELD_SX]}>
          <InputLabel>Catalog Category</InputLabel>
          <Select
            label="Catalog Category"
            value={catalogCategory}
            onChange={(e) =>
              onChange({
                catalogCategory: e.target.value as LicensePickerConfig['catalogCategory'],
                mode: value?.mode,
              })
            }
          >
            {LICENSE_CATEGORY_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={[{ minWidth: 200 }, FIELD_SX]}>
          <InputLabel>Mode</InputLabel>
          <Select
            label="Mode"
            value={mode}
            onChange={(e) =>
              onChange({
                catalogCategory,
                mode: e.target.value as NonNullable<LicensePickerConfig['mode']>,
              })
            }
          >
            <MenuItem value="all">All (existing + catalog)</MenuItem>
            <MenuItem value="existing-only">Existing customer licenses only</MenuItem>
          </Select>
        </FormControl>
      </Stack>
    </Box>
  );
};
